module.exports = __webpack_public_path__ + "static/media/wall.e03ee343.jpg";